import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-76dcacbe")

_pushScopeId("data-v-76dcacbe")
const _hoisted_1 = { class: "widePage hasHeader" }
const _hoisted_2 = { key: 0 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_chat_header = _resolveComponent("chat-header")!
  const _component_chat_component = _resolveComponent("chat-component")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (!_ctx.loading && !_ctx.isError)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode(_component_chat_header, {
            hasUserInfo: _ctx.chatVm,
            hasOptions: _ctx.chatVm,
            onOpenDetail: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openDetail())),
            onSettingsModal: _cache[2] || (_cache[2] = ($event: any) => (_ctx.settingsModal())),
            userIdentifier: _ctx.chatVm.userIdentifier,
            userName: _ctx.chatVm.name
          }, null, 8, ["hasUserInfo", "hasOptions", "userIdentifier", "userName"]),
          _createVNode(_component_chat_component, {
            "chat-room": _ctx.chatVm,
            "container-adjustment": 3,
            "container-adjustment-oko": 83,
            style: {},
            "can-write": _ctx.canWrite
          }, null, 8, ["chat-room", "can-write"])
        ]))
      : _createCommentVNode("", true)
  ]))
})